// src/Components/MainModal.tsx
import React, { useEffect, useMemo, useState } from "react";
import { Col, Modal, Row, Card, Offcanvas, Table, Form, Button, Image, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";

//img
import modalImg from "assets/images/subscribe.png";
import logodark from "assets/images/logo-dark.png";
import logolight from "assets/images/logo-light.png";
import fallbackImg from "assets/images/products/img-1.png";

// cart api
import {
  useGetStoreCartQuery,
  useUpdateCartItemQtyMutation,
  useRemoveCartItemMutation,
} from "../redux/services/store/storeCartApi";
import { useListStoreProductsPageQuery } from "../redux/services/store/storeProductsApi";

//go to one page to another page opne modal
export const MainModal = ({ location }: any) => {
  const [show, setShow] = useState(false);
  const modalhide = () => setShow(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(false);
    }, 2000);
  }, [location]);

  return (
    <React.Fragment>
      <Modal show={show} onHide={modalhide} id="subscribeModal" contentClassName="border-0" size="lg" centered>
        <Modal.Body className="p-0 bg-info-subtle rounded">
          <Row className="g-0 align-items-center">
            <Col lg={6}>
              <div className="p-4 h-100">
                <span className="badge bg-info-subtle text-info fs-13">GET 10% SALE OFF</span>
                <h2 className="display-6 mt-2 mb-3">
                  Subscribe &amp; Get <b>50% Special</b> Discount On Email
                </h2>
                <p className="mb-4 pb-lg-2 fs-16">Join our newsletter to receive the latest updates and promotion</p>
                <Form action="#">
                  <div className="position-relative ecommerce-subscript">
                    <Form.Control type="email" className="rounded-pill border-0" placeholder="Enter your email" />
                    <Button type="submit" className="btn btn-info btn-hover rounded-pill">
                      Subscript
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
            <Col lg={6}>
              <div className="p-4 pb-0">
                <Image src={modalImg} alt="" fluid />
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

//===============================================

//invoice modal
export const InvoiceModal = ({ modal, handleClose }: any) => {
  const InvoicePrint = () => {
    window.print();
  };
  return (
    <React.Fragment>
      <Modal
        show={modal}
        onHide={handleClose}
        animation={true}
        dialogClassName="modal-custom-size"
        id="invoiceModal"
        aria-labelledby="invoiceModalLabel"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5" id="invoiceModalLabel">
            Invoice #TTB30280001
          </h1>
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-0" id="demo">
            <Row>
              <Col lg={12}>
                <Card.Header className="border-bottom-dashed p-4">
                  <div className="d-sm-flex">
                    <div className="flex-grow-1">
                      <Image src={logodark} className="card-logo card-logo-dark" alt="logo dark" height="26" />
                      <Image src={logolight} className="card-logo card-logo-light" alt="logo light" height="26" />
                      <div className="mt-sm-5 mt-4">
                        <h6 className="text-muted text-uppercase fw-semibold fs-14">Address</h6>
                        <p className="text-muted mb-1" id="address-details">
                          Phoenix, USA
                        </p>
                        <p className="text-muted mb-0" id="zip-code">
                          <span>Zip-code:</span> 90201
                        </p>
                      </div>
                    </div>
                    <div className="flex-shrink-0 mt-sm-0 mt-3">
                      <h6>
                        <span className="text-muted fw-normal">Legal Registration No:</span>{" "}
                        <span id="legal-register-no">987654</span>
                      </h6>
                      <h6>
                        <span className="text-muted fw-normal">Email:</span> <span id="email">info@fionaziya.in</span>
                      </h6>
                      <h6>
                        <span className="text-muted fw-normal">Website:</span>{" "}
                        <Link to="https://fionaziya.in/" className="link-primary" target="_blank" id="website">
                          www.FionaZiya.in
                        </Link>
                      </h6>
                      <h6 className="mb-0">
                        <span className="text-muted fw-normal">Contact No: </span>
                        <span id="contact-no"> +(314) 234 6789</span>
                      </h6>
                    </div>
                  </div>
                </Card.Header>
                <Col lg={12}>
                  <Card.Body className="p-4">
                    <Row className="g-3">
                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">Invoice No</p>
                        <h5 className="fs-15 mb-0">
                          #TTB<span id="invoice-no">30280001</span>
                        </h5>
                      </Col>

                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">Date</p>
                        <h5 className="fs-15 mb-0">
                          <span id="invoice-date">14 Jan, 2023</span>{" "}
                          <small className="text-muted" id="invoice-time">
                            12:22PM
                          </small>
                        </h5>
                      </Col>

                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">Payment Status</p>
                        <span className="badge bg-success-subtle" id="payment-status">
                          Paid
                        </span>
                      </Col>

                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">Total Amount</p>
                        <h5 className="fs-15 mb-0">
                          $<span id="total-amount">1406.92</span>
                        </h5>
                      </Col>
                    </Row>
                  </Card.Body>
                </Col>
                <Col lg={12}>
                  <Card.Body className="p-4 border-top border-top-dashed">
                    <Row className="g-3">
                      <Col xs={6}>
                        <h6 className="text-muted text-uppercase fw-semibold fs-14 mb-3">Billing Address</h6>
                        <p className="fw-medium mb-2 fs-16" id="billing-name">
                          Raquel Murillo
                        </p>
                        <p className="text-muted mb-1" id="billing-address-line-1">
                          4430 Holt Street, Miami, Florida-33169
                        </p>
                        <p className="text-muted mb-1">
                          <span>Phone: +</span>
                          <span id="billing-phone-no">(123) 561-238-1000</span>
                        </p>
                        <p className="text-muted mb-0">
                          <span>Tax: </span>
                          <span id="billing-tax-no">65-498700</span>{" "}
                        </p>
                      </Col>

                      <Col xs={6}>
                        <h6 className="text-muted text-uppercase fw-semibold fs-14 mb-3">Shipping Address</h6>
                        <p className="fw-medium mb-2 fs-16" id="shipping-name">
                          Raquel Murillo
                        </p>
                        <p className="text-muted mb-1" id="shipping-address-line-1">
                          4430 Holt Street, Miami, Florida-33169
                        </p>
                        <p className="text-muted mb-1">
                          <span>Phone: +</span>
                          <span id="shipping-phone-no">(123) 561-238-1000</span>
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Col>
                <Col lg={12}>
                  <Card.Body className="p-4">
                    <div className="table-responsive">
                      <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                        <thead>
                          <tr className="table-active">
                            <th scope="col" style={{ width: "50px" }}>
                              #
                            </th>
                            <th scope="col">Product Details</th>
                            <th scope="col">Rate</th>
                            <th scope="col">Quantity</th>
                            <th scope="col" className="text-end">
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody id="products-list">
                          <tr>
                            <th scope="row">01</th>
                            <td className="text-start">
                              <span className="fw-medium">World's most expensive t shirt</span>
                              <p className="text-muted mb-0">Graphic Print Men &amp; Women Sweatshirt</p>
                            </td>
                            <td>$266.24</td>
                            <td>03</td>
                            <td className="text-end">$798.72</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <div className="border-top border-top-dashed mt-2">
                      <Table className="table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                        <tbody>
                          <tr>
                            <td>Sub Total</td>
                            <td className="text-end">$1376.33</td>
                          </tr>
                          <tr>
                            <td>Estimated Tax (12.5%)</td>
                            <td className="text-end">$172.04</td>
                          </tr>
                          <tr>
                            <td>
                              Discount <small className="text-muted">(TONER50)</small>
                            </td>
                            <td className="text-end">- $206.45</td>
                          </tr>
                          <tr>
                            <td>Shipping Charge</td>
                            <td className="text-end">$65.00</td>
                          </tr>
                          <tr className="border-top border-top-dashed fs-15">
                            <th scope="row">Total Amount</th>
                            <th className="text-end">$1406.92</th>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <div className="mt-3">
                      <h6 className="text-muted text-uppercase fw-semibold mb-3">Payment Details:</h6>
                      <p className="text-muted mb-1">
                        Payment Method: <span className="fw-medium" id="payment-method">Mastercard</span>
                      </p>
                      <p className="text-muted mb-1">
                        Card Holder: <span className="fw-medium" id="card-holder-name">Raquel Murillo</span>
                      </p>
                      <p className="text-muted mb-1">
                        Card Number: <span className="fw-medium" id="card-number">xxx xxxx xxxx 1234</span>
                      </p>
                      <p className="text-muted">
                        Total Amount: <span className="fw-medium">$ </span>
                        <span id="card-total-amount">1406.92</span>
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="alert alert-info">
                        <p className="mb-0">
                          <span className="fw-semibold">NOTES:</span>
                          <span id="note">
                            All accounts are to be paid within 7 days from receipt of invoice. To be paid by cheque or
                            credit card or direct payment online. If account is not paid within 7 days the credits details
                            supplied as confirmation of work undertaken will be charged the agreed quoted fee noted above.
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                      <Link to="print()" className="btn btn-success" onClick={InvoicePrint}>
                        <i className="ri-printer-line align-bottom me-1"></i> Print
                      </Link>
                      <Link to="#" className="btn btn-primary">
                        <i className="ri-download-2-line align-bottom me-1"></i> Download
                      </Link>
                    </div>
                  </Card.Body>
                </Col>
              </Col>
            </Row>
          </Card>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

//=======================================================

//search modal
const SEARCH_RESULTS_LIMIT = 8;
const SEARCH_DEBOUNCE_MS = 300;

export const SearchModal = ({ show, handleClose }: any) => {
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedValue(value.trim());
    }, SEARCH_DEBOUNCE_MS);

    return () => window.clearTimeout(timeoutId);
  }, [value]);

  useEffect(() => {
    if (!show) {
      setValue("");
      setDebouncedValue("");
    }
  }, [show]);

  const searchTerm = debouncedValue.trim();
  const shouldSearch = show && searchTerm.length > 0;
  const showDropdown = show && value.trim().length > 0;

  const { data, isFetching } = useListStoreProductsPageQuery(
    {
      skip: 0,
      limit: SEARCH_RESULTS_LIMIT,
      q: searchTerm,
    },
    {
      skip: !shouldSearch,
    }
  );

  const items = data?.items ?? [];

  const closeModal = () => {
    handleClose?.();
  };

  const clearSearch = () => {
    setValue("");
    setDebouncedValue("");
  };

  const openResultsPage = (rawValue: string) => {
    const next = String(rawValue || "").trim();
    if (!next) return;
    closeModal();
    navigate(`/catalog/clothing?q=${encodeURIComponent(next)}`);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    openResultsPage(value);
  };

  return (
    <React.Fragment>
      <Modal show={show} onHide={handleClose} size="lg" contentClassName="rounded" id="searchModal">
        <Modal.Header className="p-3">
          <Form className="position-relative w-100" onSubmit={handleSubmit}>
            <Form.Control
              type="text"
              className="form-control-lg border-2"
              placeholder="Search by product name, ID or SKU..."
              id="search-options"
              value={value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setValue(e.target.value)
              }
              autoComplete="off"
            />
            <span className="bi bi-search search-widget-icon fs-17"></span>
            <Button
              type="button"
              className="search-widget-icon fs-14 link-secondary text-decoration-underline search-widget-icon-close"
              id="search-close-options"
              variant="link"
              onClick={clearSearch}
              style={{ display: value.trim() ? "inline-flex" : "none" }}
            >
              Clear
            </Button>
          </Form>
        </Modal.Header>

        <div
          className={`dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 overflow-hidden${showDropdown ? " show" : ""}`}
          id="search-dropdown"
        >
          <div className="dropdown-head rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-14 text-muted fw-semibold">
                    {showDropdown ? "PRODUCT SEARCH" : "SEARCH PRODUCTS"}
                  </h6>
                </Col>
              </Row>
            </div>

            <div className="dropdown-item bg-transparent text-wrap">
              {showDropdown ? (
                <Button
                  type="button"
                  variant="soft-secondary"
                  size="sm"
                  className="btn btn-soft-secondary btn-sm btn-rounded"
                  onClick={() => openResultsPage(value)}
                >
                  View all results for "{value.trim()}"
                </Button>
              ) : (
                <span className="text-muted fs-13">
                  Search using product name, exact product ID, or SKU.
                </span>
              )}
            </div>
          </div>

          <SimpleBar className="pe-2 ps-3 mt-3" style={{ maxHeight: "300px" }}>
            <div className="list-group list-group-flush border-dashed">
              {!showDropdown ? (
                <div className="px-2 pb-3 text-muted fs-13">
                  Start typing to search products from your live catalog.
                </div>
              ) : isFetching ? (
                <div className="d-flex align-items-center justify-content-center py-4 text-muted">
                  <Spinner animation="border" size="sm" className="me-2" />
                  Searching products...
                </div>
              ) : items.length > 0 ? (
                <div className="notification-group-list">
                  <h5 className="text-overflow text-muted fs-13 mb-2 mt-1 text-uppercase notification-title">
                    Products
                  </h5>
                  {items.map((item) => (
                    <Link
                      key={item.id}
                      to={`/product/${item.slug}`}
                      className="list-group-item dropdown-item notify-item"
                      onClick={closeModal}
                    >
                      <div className="d-flex align-items-center">
                        <Image
                          src={item.image?.cdn_url || fallbackImg}
                          alt={item.image?.alt_text || item.name}
                          className="avatar-sm flex-shrink-0 me-3 rounded"
                        />
                        <div className="flex-grow-1">
                          <div className="fw-semibold text-truncate">{item.name}</div>
                          <div className="fs-12 text-muted">
                            Product ID: #{item.id}
                            {item.price_from ? ` | ${item.currency_code || "INR"} ${item.price_from}` : ""}
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="px-2 pb-3">
                  <div className="text-muted fs-13 mb-2">
                    No matching products found for "{value.trim()}".
                  </div>
                  <Button
                    type="button"
                    variant="soft-secondary"
                    size="sm"
                    className="btn btn-soft-secondary btn-sm"
                    onClick={() => openResultsPage(value)}
                  >
                    Search full catalog
                  </Button>
                </div>
              )}
            </div>
          </SimpleBar>
        </div>
      </Modal>
    </React.Fragment>
  );
};

//===================================================

//card modal
export const CardModal = ({ show, handleClose }: any) => {
  const { data, isLoading, isFetching, isError } = useGetStoreCartQuery({} as any, { skip: !show });

  const cart = (data as any)?.cart ?? null;

  const items = useMemo(
    () =>
      Array.isArray((data as any)?.items)
        ? (data as any).items
        : Array.isArray(cart?.items)
          ? cart.items
          : [],
    [data, cart]
  );

  const [updateQty, { isLoading: isQtyLoading }] = useUpdateCartItemQtyMutation();
  const [removeItem, { isLoading: isRemoveLoading }] = useRemoveCartItemMutation();

  const toNum = (v: any) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const parseQty = (v: any): number => {
    const n = Number(v);
    if (!Number.isFinite(n)) return 1;
    return Math.max(1, Math.round(n));
  };

  const formatQtyForApi = (n: number): number => {
    const safe = Math.max(1, Math.min(100, Math.round(n)));
    return safe;
  };

  const currency = cart?.currency_code || "INR";

  const subtotal = useMemo(() => {
    const backendSubtotal = (data as any)?.totals?.subtotal;
    if (backendSubtotal != null) return toNum(backendSubtotal);
    return items.reduce((sum: number, it: any) => sum + toNum(it?.line_total ?? 0), 0);
  }, [data, items]);

  const total = useMemo(() => {
    const backendTotal = (data as any)?.totals?.total;
    if (backendTotal != null) return toNum(backendTotal);
    return subtotal;
  }, [data, subtotal]);

  const busy = isLoading || isFetching || isQtyLoading || isRemoveLoading;

  const countUP = async (it: any) => {
    const current = parseQty(it?.qty);
    const next = Math.min(100, current + 1);
    try {
      await updateQty({ id: it.id, qty: formatQtyForApi(next) }).unwrap();
    } catch (e) {
      console.log(e);
    }
  };

  const countDown = async (it: any) => {
    const current = parseQty(it?.qty);
    const next = Math.max(1, current - 1);
    try {
      await updateQty({ id: it.id, qty: formatQtyForApi(next) }).unwrap();
    } catch (e) {
      console.log(e);
    }
  };

  const onRemoveClick = async (itemId: number) => {
    try {
      await removeItem({ id: itemId }).unwrap();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <React.Fragment>
      <Offcanvas show={show} onHide={handleClose} backdrop="static" placement="end">
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title id="ecommerceCartLabel" as="h5">
            My Cart{" "}
            <span className="badge bg-danger align-middle ms-1 cartitem-badge">{items.length}</span>
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-0">
          <SimpleBar className="h-100">
            {isError ? (
              <div className="p-3 text-danger">Failed to load cart</div>
            ) : isLoading ? (
              <div className="p-4 text-center">
                <Spinner animation="border" size="sm" /> Loading...
              </div>
            ) : (
              <>
                <ul className="list-group list-group-flush cartlist">
                  {(items || []).map((it: any, inx: number) => {
                    const p = it?.product || {};
                    const title = p?.name || `Variant #${p?.variant_id ?? it?.variant_id ?? ""}`;
                    const img = p?.image?.cdn_url || "https://via.placeholder.com/80x80.png?text=IMG";

                    const itemPrice = toNum(it?.unit_price);
                    const qty = parseQty(it?.qty);
                    const lineTotal = toNum(it?.line_total);

                    const compareAt =
                      p?.compare_at_price != null
                        ? toNum(p.compare_at_price)
                        : it?.compare_at_price != null
                        ? toNum(it.compare_at_price)
                        : null;

                    return (
                      <li key={it?.id ?? inx} className="list-group-item product">
                        <div className="d-flex gap-3">
                          <div className="flex-shrink-0">
                            <div className="avatar-md bg-light-subtle rounded-3 overflow-hidden" style={{ height: "100%" }}>
                              <Image
                                src={img}
                                alt=""
                                className="w-100 h-100"
                                style={{ objectFit: "cover", objectPosition: "center", display: "block" }}
                              />
                            </div>
                          </div>

                          <div className="flex-grow-1">
                            <Link to={`/product/${p?.slug || ""}`}>
                              <h5 className="fs-15">{title}</h5>
                            </Link>

                            <div className="d-flex flex-column mb-2 gap-1">
                              {compareAt != null && compareAt > itemPrice ? (
                                <div className="text-muted mb-0" style={{ textDecoration: "line-through" }}>
                                  {currency} {compareAt.toFixed(2)}
                                </div>
                              ) : null}
                            </div>

                            <div className="input-step">
                              <Button className="minus" onClick={() => countDown(it)} disabled={busy}>
                                –
                              </Button>
                              <Form.Control type="number" className="product-quantity" value={qty} min="1" max="100" readOnly />
                              <Button className="plus" onClick={() => countUP(it)} disabled={busy}>
                                +
                              </Button>
                            </div>
                          </div>

                          <div className="flex-shrink-0 d-flex flex-column justify-content-between align-items-end">
                            <Button
                              className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn"
                              onClick={() => onRemoveClick(it.id)}
                              disabled={busy}
                            >
                              <i className="ri-close-fill fs-16"></i>
                            </Button>
                            <div className="fw-medium mb-0 fs-16">
                              {currency} <span className="product-line-price">{lineTotal.toFixed(2)}</span>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>

                <div className="table-responsive mx-2 border-top border-top-dashed">
                  <Table className="table table-borderless mb-0 fs-14 fw-semibold">
                    <tbody>
                      <tr>
                        <td>Sub Total :</td>
                        <td className="text-end cart-subtotal">
                          {currency} {subtotal.toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </SimpleBar>
        </Offcanvas.Body>

        <div className="offcanvas-footer border-top p-3 text-center">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="m-0 fs-16 text-muted">Total:</h6>
            <div className="px-2">
              <h6 className="m-0 fs-16 cart-total">
                {currency} {Number(total).toFixed(2)}
              </h6>
            </div>
          </div>

          <Row className="g-2">
            <Col xs={6}>
              <Link
                to="/shop/shopingcard"
                className={`btn btn-light w-100 ${busy ? "disabled" : ""}`}
                onClick={() => handleClose?.()}
              >
                View Cart
              </Link>
            </Col>
            <Col xs={6}>
              <Link
                to="/shop/checkout"
                className={`btn btn-info w-100 ${busy ? "disabled" : ""}`}
                onClick={() => handleClose?.()}
              >
                Continue to Checkout
              </Link>
            </Col>
          </Row>
        </div>
      </Offcanvas>
    </React.Fragment>
  );
};
